export default "/images/d46f088cd8fa760e75977f6c620d6eb9.avif";